export const ProductsIcon = () => {
	return (
		<div>
			<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
				<path
					d="M8.66665 4.66671C6.45751 4.66671 4.66665 6.45757 4.66665 8.66671C4.66665 10.8758 6.45751 12.6667 8.66665 12.6667C10.8758 12.6667 12.6666 10.8758 12.6666 8.66671C12.6666 6.45757 10.8758 4.66671 8.66665 4.66671ZM3.33331 8.66671C3.33331 5.72119 5.72113 3.33337 8.66665 3.33337C11.6122 3.33337 14 5.72119 14 8.66671C14 9.89918 13.5819 11.034 12.8799 11.9371L16.4714 15.5286C16.7317 15.789 16.7317 16.2111 16.4714 16.4714C16.211 16.7318 15.7889 16.7318 15.5286 16.4714L11.9371 12.8799C11.034 13.582 9.89912 14 8.66665 14C5.72113 14 3.33331 11.6122 3.33331 8.66671Z"
					fill="#797F84"
				/>
			</svg>
		</div>
	)
}
